import React from 'react'
import { observer, inject } from 'mobx-react'
import LoadingComponent from '../../../LoadingComponent'
import SearchForm from './Form'
import { present } from '../settings/Form/validators'

@inject('searches', 'websites')
@observer
export default class EditSearch extends LoadingComponent {
  website = this.props.websites.current

  hasLoaded() {
    return this.props.searches.loaded
  }

  constructor(props, ...args) {
    super(props, ...args)
    this.props.searches.load(this.props.params.searchId)
  }

  handleData = data => {
    if (this.props.duplicate) {
      return this.props.searches.create(data)
    } else {
      return this.props.searches.update(data)
    }
  }

  getSearch() {
    return this.props.searches.findById(this.props.params.searchId)
  }
  
  /*
   * Validate for a unique title, except in cases where the new title matches
   * the existing title.
  
   * Based on how our validations are set up, we are returning false for unique
   * titles and true for non-unique titles.
   * 
   * In the future, it would be great if a method like this could be abstracted
   * to live with our other validators.
   */
  uniqueTitle = (title) => {
    const existingTitle = this.getSearch().title
    if (existingTitle === title) return false
    
    else {
      const duplicate = this.props.searches.find(s => s.title === title)
      return !!duplicate
    }
  }

  renderLoaded() {
    const search = this.getSearch()
    const { duplicate } = this.props
    const validations = [
      { field: 'title', validate: present, message: 'Please Enter a Search Name' },
      { field: 'title', validate: this.uniqueTitle, message: 'Please Enter a Unique Search Name' }
    ]
    return (
      <SearchForm
        search={search}
        duplicate={duplicate}
        onData={this.handleData}
        validations={validations} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/SearchLibrary/Edit.js